import { Button, Input, Space, Table } from "antd";
import { useState } from "react";
import { StaticModal } from "./StaticModal";

export type LookupItem = { id: number; label: string; subtitle?: string };

interface LookupModalProps {
  title: string;
  open: boolean;
  onClose: () => void;
  onSelect: (item: LookupItem) => void;
  fetcher: (q: string, page: number, pageSize: number) => Promise<{ items: LookupItem[]; total: number }>;
  onAddNew?: () => void;
  searchPlaceholder?: string;
}

export const LookupModal = ({
  title, open, onClose, onSelect, fetcher, onAddNew,
  searchPlaceholder = "Search...",
}: LookupModalProps) => {
  const [rows, setRows] = useState<LookupItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  const load = async (q: string, pg: number) => {
    setLoading(true);
    try {
      const r = await fetcher(q, pg, 20);
      setRows(r.items ?? []);
      setTotal(r.total ?? 0);
      setPage(pg);
    } catch { /* silent */ } finally { setLoading(false); }
  };

  return (
    <StaticModal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      destroyOnClose
      maskClosable={false}
      keyboard={false}
      afterOpenChange={(vis) => { if (vis) { setQuery(""); void load("", 1); } }}
    >
      <Space style={{ marginBottom: 12 }}>
        <Input.Search
          placeholder={searchPlaceholder}
          allowClear
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onSearch={(v) => { setQuery(v); void load(v, 1); }}
          style={{ width: 340 }}
        />
        {onAddNew && <Button onClick={onAddNew}>Add New</Button>}
      </Space>
      <Table
        rowKey="id"
        size="small"
        loading={loading}
        dataSource={rows}
        pagination={{
          current: page, total, pageSize: 20, showSizeChanger: false,
          onChange: (p) => void load(query, p),
        }}
        columns={[
          { title: "ID", dataIndex: "id", width: 60 },
          { title: "Name", dataIndex: "label" },
          {
            title: "Details", dataIndex: "subtitle",
            render: (v: string) => <span style={{ color: "#6b7280", fontSize: 12 }}>{v}</span>,
          },
          {
            title: "", width: 80,
            render: (_, row) => (
              <Button size="small" type="primary" onClick={() => onSelect(row)}>Select</Button>
            ),
          },
        ]}
      />
    </StaticModal>
  );
};
